import { render, staticRenderFns } from "./ChatOfferModal.vue?vue&type=template&id=abd760c2&scoped=true&"
import script from "./ChatOfferModal.vue?vue&type=script&lang=js&"
export * from "./ChatOfferModal.vue?vue&type=script&lang=js&"
import style0 from "./ChatOfferModal.vue?vue&type=style&index=0&id=abd760c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd760c2",
  null
  
)

export default component.exports